import React, { useState } from "react";
import { Row, Spinner, Col, Modal } from "react-bootstrap";

const Loader = (props) => {
    const { show } = props;

    return (
       <Row>
            <Col lg='12'>
                <Modal id="loader" show={show} centered animation={true} size="sm" className="shadow-none">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </Modal>
            </Col>
        </Row>
    )
}

export default Loader;